
import mom from "moment"

export const sortNumber = (first, last, undefinedAlwaysLast, order) => {
  const firstUndefined = first === null || first === undefined || first === "---" || first === "N/A"
  const lastUndefined = last === null || last === undefined || last === "---" || last === "N/A"

  if (order === "asc") {
    if (firstUndefined) return 1
    if (lastUndefined) return -1

    return parseInt("" + first, 10) - parseInt("" + last, 10)
  } else {
    if (undefinedAlwaysLast) {
      if (firstUndefined) return 1
      if (lastUndefined) return -1
    } else {
      if (firstUndefined) return -1
      if (lastUndefined) return 1
    }

    return parseInt("" + last, 10) - parseInt("" + first, 10)
  }
}

export const constructManualSortingComputedProperty = (dataSource, sortSource, orderSource) => {
  const isValidDate = date => date instanceof Date && !isNaN(date.valueOf())

  return function() {
    if (!this[dataSource]) return []
    const filtered = this[dataSource].slice()
    const property = this[sortSource || "sort"]
    const order = this[orderSource || "order"]

    const nameSort = (a, b) => {
      if (a[property].localeCompare && b[property].localeCompare) {
        return order === "asc"
          ? a[property].localeCompare(b[property])
          : b[property].localeCompare(a[property])
      } else {
        if (order === 'asc') {
          if (a[property] < b[property]) return -1;
          if (a[property] > b[property]) return 1;
        } else {
          if (a[property] < b[property]) return 1;
          if (a[property] > b[property]) return -1;
        }
        return 0;
      }
    }
    property && filtered.sort((a, b) => {
      switch (property) {
        case "name": {
          return nameSort(a, b)
        }
        case "engine": {
          return sortNumber(a.engine.value, b.engine.value, true, order)
        }

        default: {
          const possibleDateA = new Date(a[property])
          const possibleDateB = new Date(b[property])
          if (isValidDate(possibleDateA) && isValidDate(possibleDateB)) {
            const dateA = mom(possibleDateA)
            const dateB = mom(possibleDateB)
            if (dateA.isValid() && dateB.isValid()) {
              if (dateA.isBefore(dateB, "minute")) return order === "asc" ? 1 : -1
              if (dateA.isAfter(dateB, "minute")) return order === "desc" ? -1 : 1
              return 0
            }
          }

          if (!isNaN(parseInt(a[property])) && !isNaN(parseInt(b[property]))) {
            return sortNumber(a[property], b[property], false, order)
          } else return nameSort(a, b)
        }
      }
    })

    return filtered
  }
}
